import { Helmet } from 'react-helmet';
import Wrapper from '@/components/common/Wrapper';
import Breadcrumbs from '@/components/navigation/Breadcrumbs';

const OGImage = `${window.cdn}smo/SMO-homepage.png`;

const routes = [
    {
        route: '/refund-and-returns-policy',
        title: 'Refund & Returns Policy',
    },
];

const terms = [
    {
        id: 1,
        title: 'Standard Refund & Returns Policy',
        paragraph:
            '<p>We are shipping perishable Products and therefore are not able to accept returns. Unlike items that have a longer shelf life, items that are perishable cannot be restocked or resold.</p><p>If you are not completely satisfied with your ButcherCrowd box for good reason, please contact <a href="mailto:support@butchercrowd.com.au">support@butchercrowd.com.au</a> within three (3) days of receipt of the product. We will happily review your order and any reported issues and offer an appropriate resolution which may include replacement of the Product in question, credit towards your next box, or a partial/full refund. Since we are not able to physically access the product, we may ask that you provide photos of the product label and the damage reported. We guarantee delivery to the address provided when the order is placed/shipped and when retrieved on the guaranteed delivery date.</p><p>Due to the perishable nature of our Product, we cannot guarantee the condition of the delivery if, the address is incorrectly entered, if a change of address isn’t updated prior to the invoice date (bill date), if an address is altered while in transit, or if you are unable to retrieve the order on the guaranteed delivery date and/or did not notify us prior to the order being invoiced. If you need help clarifying a delivery address change, please email us at support@butchercrowd.com.au.</p><p>When placing your order, please enter your shipping address carefully to ensure accuracy and review your receipt/account for any errors. If you enter the shipping address incorrectly when the order is placed, please email info@butchercrowd.com.au immediately for correction. Should your shipping address change, please update your address prior to the invoice date (bill date) via your login.</p><p>If your order is returned to us because of an incorrect address provided or refusal of delivery when shipped according to our terms and conditions, we will store your box, initiate contact and determine another delivery date that is suitable. In the event an order is delivered late due to an incorrect address or if you are unable to retrieve it on the delivery date without prior notification and thawing/damage occurs, you will not be refunded.</p>',
    },
    {
        id: 2,
        title: 'Return/Refund Policy for Cancelled Orders',
        paragraph:
            '<p>You are liable for any orders placed or charges that incur prior to the cancellation request. If the request for cancellation is made after your order has been invoiced, we are unable to provide a refund, and the delivery will be made.</p>',
    },
    {
        id: 3,
        title: 'Refund Policy for Stolen Goods',
        paragraph:
            '<p>You are liable for any orders placed. Your box becomes your responsibility of safe-keeping, upon the box being delivered. We are unable to issue refunds for stolen goods, particularly when we have not received any detailed delivery notes to help prevent such occurrences.</p>',
    },
];

export default function TermsConditionsPage() {
    return (
        <>
            <Helmet>
                <title>Refund and Returns policy | ButcherCrowd</title>
                <meta
                    name="description"
                    content="Curated or customised meat & seafood boxes delivered for your everyday cooking essentials"
                />
                <meta
                    property="og:title"
                    content="Refund and Returns policy | ButcherCrowd"
                />
                <meta
                    property="og:description"
                    content="Curated or customised meat & seafood boxes delivered for your everyday cooking essentials"
                />
                <meta property="og:image" content={OGImage} />
            </Helmet>
            <Wrapper>
                <div className="hidden px-8 pt-8 sm:block lg:mx-7">
                    <Breadcrumbs crumbs={routes} />
                </div>
                <div className="mx-4 mt-12 text-2xl font-medium sm:mt-8 md:mx-16 md:text-5xl lg:mx-40 xl:mx-80">
                    <h1 className="text-center text-3xl font-bold sm:text-4xl sm:normal-case">
                        Refund and Returns Policy
                    </h1>
                    <div className="pt-12 font-neue text-lg">
                        {terms.map((e) => (
                            <div key={e.id} className="max-w-full pb-12">
                                <div className="text-base font-bold leading-tight sm:pt-0 sm:leading-7">
                                    {e.title}
                                </div>
                                <div
                                    className="prose prose-sm mt-5 max-w-full text-base font-normal leading-7"
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: e.paragraph,
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </Wrapper>
        </>
    );
}
